import { defineMessage } from '@atlassian/jira-intl';

const allIncidentsMessage = defineMessage({
	id: 'operations.incidents.defaultFilters.all',
	defaultMessage: 'All',
	description:
		'Label for the default filter showing all incidents in the incidents sidebar navigation.',
});

const openIncidentsMessage = defineMessage({
	id: 'operations.incidents.defaultFilters.open',
	defaultMessage: 'Open',
	description:
		'Label for the default filter showing open incidents in the incidents sidebar navigation.',
});

const majorIncidentsMessage = defineMessage({
	id: 'operations.incidents.defaultFilters.major',
	defaultMessage: 'Major',
	description:
		'Label for the default filter showing major incidents in the incidents sidebar navigation.',
});

const assignedToMeIncidentsMessage = defineMessage({
	id: 'operations.incidents.defaultFilters.assignedToMe',
	defaultMessage: 'Assigned to me',
	description:
		'Label for the default filter showing incidents assigned to the current user in the incidents sidebar navigation.',
});

const closedIncidentsMessage = defineMessage({
	id: 'operations.incidents.defaultFilters.closed',
	defaultMessage: 'Closed',
	description:
		'Label for the default filter showing closed incidents in the incidents sidebar navigation.',
});

const defaultFilters: Array<{
	id: string;
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incidentSearchQuery: string;
}> = [
	{
		id: 'all',
		label: allIncidentsMessage,
		incidentSearchQuery: '',
	},
	{
		id: 'open',
		label: openIncidentsMessage,
		incidentSearchQuery: 'resolution = Unresolved',
	},
	{
		id: 'major',
		label: majorIncidentsMessage,
		incidentSearchQuery: '"Major incident" is not EMPTY',
	},
	{
		id: 'assignedToMe',
		label: assignedToMeIncidentsMessage,
		incidentSearchQuery: 'assignee = currentUser() AND resolution = Unresolved',
	},
	{
		id: 'closed',
		label: closedIncidentsMessage,
		incidentSearchQuery: 'resolution = Done',
	},
];

export default defaultFilters;
